(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-filters"] && !Shopify.designMode) return;
  try {
    class CollectionFilter {
    constructor(container) {
      this.container = container;
      this.currentFilter = null;
      this.isLoading = false;
      this.productCache = new Map();
      this.mode = container.dataset.interactionMode || 'filter';
      this.isLinkMode = this.mode === 'link';
      this.shopAllUrl = container.dataset.shopAllUrl;
      this.shopAllLabel = container.dataset.shopAllLabel;
      this.activeHandle = container.dataset.activeHandle;
      this.dataKey = container.dataset.instanceId;
      
      // Get settings from window.collectionFilterData
      let dataKey = this.dataKey;
      if (!dataKey || !window.collectionFilterData[dataKey]) {
        dataKey = Object.keys(window.collectionFilterData).find(key => {
          return window.collectionFilterData[key].collections;
        });
      }
      this.data = window.collectionFilterData[dataKey] || window.collectionFilterData;
      this.dataKey = dataKey;
      this.settings = this.data.settings || {};

      if (!this.mode && this.data.interactionMode) {
        this.mode = this.data.interactionMode;
        this.isLinkMode = this.mode === 'link';
      }
      if (!this.shopAllUrl && this.data.shopAllUrl) {
        this.shopAllUrl = this.data.shopAllUrl;
      }
      if (!this.shopAllLabel && this.data.shopAllLabel) {
        this.shopAllLabel = this.data.shopAllLabel;
      }
      if (!this.activeHandle && this.data.activeHandle) {
        this.activeHandle = this.data.activeHandle;
      }
      if (!this.shopAllUrl && this.data.collections && this.data.collections.length > 0) {
        this.shopAllUrl = this.data.collections[0].url;
      }
      if (!this.shopAllLabel) {
        this.shopAllLabel = 'Shop All';
      }
      
      this.init();
    }

    init() {
      this.bindFilterClicks();
      this.bindDropdownChange();
      this.loadInitialFilter();
    }

    getData() {
      return this.data;
    }

    bindFilterClicks() {
      const filters = this.container.querySelectorAll('.badge-filter[data-filter]');

      filters.forEach(filter => {
        filter.addEventListener('click', (e) => {
          e.preventDefault();
          const filterHandle = filter.getAttribute('data-filter');

          if (filterHandle === 'submit') {
            this.handleSubmitClick();
          } else {
            this.handleFilterClick(filter, filterHandle);
          }
        });
      });
    }

    bindDropdownChange() {
  const dropdownButton = this.container.querySelector('.filter-dropdown__button');
  const dropdownMenu = this.container.querySelector('.filter-dropdown__menu');
  const dropdownText = this.container.querySelector('.filter-dropdown__text');
      const dropdownItems = this.container.querySelectorAll('.filter-dropdown__item');

      if (!dropdownButton || !dropdownMenu) return;

      // Toggle dropdown
      dropdownButton.addEventListener('click', (e) => {
        e.stopPropagation();
        const isOpen = dropdownButton.getAttribute('aria-expanded') === 'true';
        
        if (isOpen) {
          this.closeDropdown();
        } else {
          this.openDropdown();
        }
      });

      // Handle item selection
      dropdownItems.forEach(item => {
        item.addEventListener('click', (e) => {
          e.stopPropagation();
          const handle = item.getAttribute('data-value');
          const title = item.getAttribute('data-title');

          // Update button display
          if (dropdownText) {
            dropdownText.textContent = title;
          }

          // Update selected state
          dropdownItems.forEach(i => i.classList.remove('is-selected'));
          item.classList.add('is-selected');

          // Close dropdown
          this.closeDropdown();

          // Update active states on carousel badges
          this.syncCarouselWithDropdown(handle);
          
          // Update submit button text
          this.updateSubmitButtonText(handle);
          
          // Load products for this collection
          this.loadProducts(handle);
        });
      });

      // Close dropdown when clicking outside
      document.addEventListener('click', (e) => {
        if (!this.container.contains(e.target)) {
          this.closeDropdown();
        }
      });
    }

    openDropdown() {
      const dropdownButton = this.container.querySelector('.filter-dropdown__button');
      const dropdownMenu = this.container.querySelector('.filter-dropdown__menu');
      
      if (dropdownButton && dropdownMenu) {
        dropdownButton.setAttribute('aria-expanded', 'true');
        dropdownMenu.classList.add('is-open');
      }
    }

    closeDropdown() {
      const dropdownButton = this.container.querySelector('.filter-dropdown__button');
      const dropdownMenu = this.container.querySelector('.filter-dropdown__menu');
      
      if (dropdownButton && dropdownMenu) {
        dropdownButton.setAttribute('aria-expanded', 'false');
        dropdownMenu.classList.remove('is-open');
      }
    }

    syncCarouselWithDropdown(handle) {
      // Update active state on carousel badges
      const badges = this.container.querySelectorAll('.badge-filter[data-filter]');
      badges.forEach(badge => {
        const badgeHandle = badge.getAttribute('data-filter');
        const isActive = badgeHandle === handle;
        badge.classList.toggle('active', isActive);
        if (isActive) {
          badge.setAttribute('aria-selected', 'true');
        } else {
          badge.setAttribute('aria-selected', 'false');
        }
      });
    }

    syncDropdownWithCarousel(handle) {
      // Update dropdown selection
      const dropdownItems = this.container.querySelectorAll('.filter-dropdown__item');
      const dropdownText = this.container.querySelector('.filter-dropdown__text');
      
      dropdownItems.forEach(item => {
        const itemHandle = item.getAttribute('data-value');
        if (itemHandle === handle) {
          item.classList.add('is-selected');
          
          // Update button display
          if (dropdownText) {
            dropdownText.textContent = item.getAttribute('data-title');
          }
        } else {
          item.classList.remove('is-selected');
        }
      });
    }

    handleFilterClick(filterElement, collectionHandle) {
      if (this.isLinkMode) {
        this.updateActiveFilter(filterElement);
        this.syncDropdownWithCarousel(collectionHandle);
        this.currentFilter = collectionHandle;
        this.updateSubmitButtonText(collectionHandle);
        this.loadProducts(collectionHandle);
        return;
      }

      if (this.isLoading) return;

      // Update active states
      this.updateActiveFilter(filterElement);

      // Sync dropdown with carousel
      this.syncDropdownWithCarousel(collectionHandle);

      // Update submit button text
      this.updateSubmitButtonText(collectionHandle);

      // Load products for this collection
      this.loadProducts(collectionHandle);
    }

    updateSubmitButtonText(collectionHandle) {
      if (this.isLinkMode) {
        const submitButton = this.container.querySelector('.collection-filters__submit .badge-filter__title');
        if (submitButton && this.shopAllLabel) {
          submitButton.textContent = this.shopAllLabel;
        }
        return;
      }

      const collection = this.data.collections.find(c => c.handle === collectionHandle);
      if (collection) {
        const submitButton = this.container.querySelector('.collection-filters__submit .badge-filter__title');
        if (submitButton) {
          submitButton.textContent = `Shop ${collection.title}`;
        }
      }
    }

    handleSubmitClick() {
      if (this.isLinkMode) {
        if (this.shopAllUrl) {
          window.location.href = this.shopAllUrl;
        } else if (this.currentFilter && this.data.collections) {
          this.navigateToCollection(this.currentFilter);
        }
        return;
      }

      // Navigate to currently selected collection
      if (this.currentFilter && this.data.collections) {
        const collection = this.data.collections.find(c => c.handle === this.currentFilter);
        if (collection) {
          window.location.href = collection.url;
        }
      }
    }

    navigateToCollection(collectionHandle) {
      if (!collectionHandle || !this.data || !this.data.collections) {
        return;
      }

      const collection = this.data.collections.find(c => c.handle === collectionHandle);
      if (collection && collection.url) {
        window.location.href = collection.url;
      }
    }

    updateActiveFilter(newFilterElement) {
      // Remove active class from all filters
      const allFilters = this.container.querySelectorAll('.badge-filter');
      allFilters.forEach(filter => {
        filter.classList.remove('active');
        filter.setAttribute('aria-selected', 'false');
      });

      // Add active class to selected filter
      newFilterElement.classList.add('active');
      newFilterElement.setAttribute('aria-selected', 'true');

      // Update current filter
      this.currentFilter = newFilterElement.getAttribute('data-filter');
    }

    async loadProducts(collectionHandle) {
      if (this.isLinkMode) {
        this.navigateToCollection(collectionHandle);
        return;
      }

      if (this.isLoading) return;

      this.showLoading();
      this.currentFilter = collectionHandle;

      try {
        // Check cache first
        if (this.productCache.has(collectionHandle)) {
          this.renderProducts(this.productCache.get(collectionHandle));
          this.hideLoading();
          return;
        }

        // Fetch products from Shopify API
        const products = await this.fetchCollectionProducts(collectionHandle);

        // Cache the results
        this.productCache.set(collectionHandle, products);

        // Render products
        this.renderProducts(products);

      } catch (error) {
        this.showError();
      } finally {
        this.hideLoading();
      }
    }

    async fetchCollectionProducts(handle) {
      // Build URL with settings as parameters for the Section Rendering API
      const params = new URLSearchParams({
        section_id: 'main-collection-product-grid'
      });
      
      // Use Section Rendering API to get pre-rendered product cards
      const response = await fetch(
        `/collections/${handle}?${params.toString()}`
      );

      if (!response.ok) {
        throw new Error(`Failed to fetch products: ${response.status}`);
      }

      const html = await response.text();
      
      // Parse the HTML to extract product cards
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      // Extract the product grid items from main-collection-product-grid
      const productItems = doc.querySelectorAll('#product-grid .grid__item');
      
      return Array.from(productItems);
    }

    async renderProducts(products) {
      const grid = this.container.querySelector('#products-grid');
      const emptyState = this.container.querySelector('.collection-products__empty');
      const swiperWrapper = this.container.querySelector('#products-swiper-wrapper');

      if (!products || products.length === 0) {
        grid.innerHTML = '';
        emptyState.style.display = 'block';
        swiperWrapper.style.display = 'none';
        return;
      }

      emptyState.style.display = 'none';
      swiperWrapper.style.display = 'block';

      // Clear and append the pre-rendered product nodes
      grid.innerHTML = '';
      products.forEach((productNode, index) => {
        // Clone the node and wrap it in a swiper-slide if needed
        const clone = productNode.cloneNode(true);
        
        // If it's an <li>, convert to swiper-slide div
        if (clone.tagName === 'LI') {
          const slide = document.createElement('div');
          slide.className = 'swiper-slide grid__item';
          
          // Move all content from li to the new div
          while (clone.firstChild) {
            slide.appendChild(clone.firstChild);
          }
          grid.appendChild(slide);
        } else {
          grid.appendChild(clone);
        }
      });

      // Re-initialize scroll animations for the new product cards
      if (typeof initializeScrollAnimationTrigger === 'function') {
        initializeScrollAnimationTrigger(swiperWrapper);
      }

      // Initialize swiper after DOM update
      this.initializeProductSwiper();
      
      // Show navigation arrows after animations complete
      // Calculate delay: (number of visible slides * 75ms) + 300ms buffer
      const settings = this.getData().settings;
      const visibleSlides = Math.min(products.length, settings.columns_desktop || 4);
      const animationDelay = (visibleSlides * 75) + 300;
      
      setTimeout(() => {
        swiperWrapper.classList.add('animations-complete');
      }, animationDelay);
    }

    initializeProductSwiper() {
      const swiperWrapper = this.container.querySelector('#products-swiper-wrapper');
      if (swiperWrapper) {
        // Destroy existing swiper instance if it exists
        const existingSwiper = swiperWrapper.querySelector('.swiper');
        if (existingSwiper && existingSwiper.swiperInstance) {
          existingSwiper.swiperInstance.destroy();
          existingSwiper.swiperInstance = null;
        }

        // Update swiper data attributes with settings
        const settings = this.getData().settings;
        if (existingSwiper && settings) {
          existingSwiper.setAttribute('data-slides-per-view-desktop', settings.columns_desktop);
          existingSwiper.setAttribute('data-slides-per-view-mobile', settings.columns_mobile);
        }

        // Initialize new swiper instance
        const swiper = new SwiperBase(swiperWrapper);
      }
    }

    loadInitialFilter() {
      const activeFilter = this.container.querySelector('.badge-filter.active[data-filter]');
      const firstFilter = this.container.querySelector('.badge-filter[data-filter]:not([data-filter="submit"])');

      if (this.isLinkMode) {
        let initialHandle = this.activeHandle;
        if (!initialHandle) {
          if (activeFilter) {
            initialHandle = activeFilter.getAttribute('data-filter');
          } else if (firstFilter) {
            initialHandle = firstFilter.getAttribute('data-filter');
          }
        }

        if (initialHandle && initialHandle !== 'submit') {
          this.currentFilter = initialHandle;
          this.syncDropdownWithCarousel(initialHandle);
        }

        this.updateSubmitButtonText(initialHandle);
        return;
      }

      // Find the first active filter or the first filter
      const initialFilter = activeFilter || firstFilter;
      if (initialFilter) {
        const handle = initialFilter.getAttribute('data-filter');
        if (handle !== 'submit') {
          this.currentFilter = handle;

          // Sync dropdown with initial filter
          this.syncDropdownWithCarousel(handle);

          // Check if products are already rendered in the DOM (pre-rendered via Liquid)
          const grid = this.container.querySelector('#products-grid');
          const hasPrerenderedProducts = grid && grid.children.length > 0;

          if (hasPrerenderedProducts) {
            // Cache the pre-rendered products
            const productNodes = Array.from(grid.children);
            this.productCache.set(handle, productNodes);

            // Initialize swiper with existing products
            this.initializeProductSwiper();

            // Show navigation arrows after animations complete
            const swiperWrapper = this.container.querySelector('#products-swiper-wrapper');
            const visibleSlides = Math.min(productNodes.length, 4);
            const animationDelay = (visibleSlides * 75) + 300;

            setTimeout(() => {
              swiperWrapper.classList.add('animations-complete');
            }, animationDelay);
          } else {
            // No pre-rendered products, load via JavaScript
            this.loadProducts(handle);
          }
        }
      }
    }

    showLoading() {
      this.isLoading = true;
      const loading = this.container.querySelector('.collection-products__loading');
      const swiperWrapper = this.container.querySelector('#products-swiper-wrapper');
      const empty = this.container.querySelector('.collection-products__empty');

      loading.style.display = 'block';
      swiperWrapper.style.display = 'none';
      empty.style.display = 'none';
    }

    hideLoading() {
      this.isLoading = false;
      const loading = this.container.querySelector('.collection-products__loading');

      loading.style.display = 'none';
      // Note: swiperWrapper visibility is handled in renderProducts
    }

    showError() {
      const swiperWrapper = this.container.querySelector('#products-swiper-wrapper');
      const grid = this.container.querySelector('#products-grid');

      swiperWrapper.style.display = 'block';
      grid.innerHTML = '<div class="swiper-slide grid__item"><div class="error-message">Failed to load products. Please try again.</div></div>';
    }
  }

  document.addEventListener('DOMContentLoaded', function() {
    // Initialize Swiper
    const filterLists = document.querySelectorAll('.swiper-wrapper-base.filter-list');
    filterLists.forEach(filterList => {
      new SwiperBase(filterList);
    });

    // Initialize Collection Filters
    const filterContainers = document.querySelectorAll('.collection-filters');
    filterContainers.forEach(container => {
      new CollectionFilter(container);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
